String.format = function (s, ...args) {
    if (!s) {
        return '';
    }
    return s.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match;
    });
};
//# sourceMappingURL=string-extension.js.map